<template>
  <v-row>
    <div class="col-md-12 home-box">
      <Breadcrumbs :title="'Stock Transfers'"></Breadcrumbs>
      <StockTransferList></StockTransferList>
    </div>
    <div class="col-md-12 home-tabs-body"></div>
  </v-row>
</template>

<script>
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue";
import StockTransferList from "@/components/stockTransfer/StockTransferList.vue";
export default {
  components: { Breadcrumbs, StockTransferList },
};
</script>
